(function () {
    'use strict';
 
    angular
        .module('app')
        .filter('nl2br', nl2br);

function nl2br($sce){
    return function(msg) { 

        if(msg.indexOf("<br />")===-1 && msg.indexOf("<br>")===-1){
        	msg = msg.replace(/\n/g, "<br />");
        }

//        msg = msg.replace(/(<p[^>]+?>|<p>|<\/p>)/g, "")
        
        return msg;
        

    };
}
})();
